module.exports = __webpack_public_path__ + "static/media/AB_Z10_1.9a531d5f.jpg";